import React, {createContext, useContext, useRef} from 'react'
import PropTypes from 'prop-types'

const WishlistIconRefContext = createContext(null)

export const WishlistIconRefProvider = ({children}) => {
    const iconRef = useRef(null)
    return (
        <WishlistIconRefContext.Provider value={iconRef}>
            {children}
        </WishlistIconRefContext.Provider>
    )
}

export const useWishlistIconRef = () => {
    return useContext(WishlistIconRefContext)
}

WishlistIconRefProvider.propTypes = {
    children: PropTypes.node.isRequired,
}
